// extracted by mini-css-extract-plugin
export default {"content":"SuccessDialog_content__poFf5","description":"SuccessDialog_description__FYQyT","title":"SuccessDialog_title__hqJW1"};